var _metadata, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 74 76",
    id: "svg8959",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8963"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8950"
  }, /*#__PURE__*/React.createElement("filter", {
    x: "-23.9%",
    y: "-17.9%",
    width: "147.8%",
    height: "135.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset8937"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    id: "feGaussianBlur8939"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098039   0 0 0 0 0.149019608   0 0 0 0 0.164705882  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    id: "feColorMatrix8941"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "feMerge8947"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1",
    id: "feMergeNode8943"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic",
    id: "feMergeNode8945"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(3,0,0,3,-74.000917,-76.019946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-225,-566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ovladani",
    transform: "translate(144,344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-copy-2",
    transform: "translate(98,239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duplikovat",
    transform: "translate(9,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.647417,6.985 H 0.93591667 C 0.73333333,6.985 0.56925,7.15 0.56925,7.3516667 V 21.064083 c 0,0.202584 0.16408333,0.366667 0.36666667,0.366667 H 14.648333 c 0.202584,0 0.366667,-0.165 0.366667,-0.366667 V 7.3525833 C 15.014083,7.15 14.85,6.985 14.647417,6.985 Z m -0.36575,13.712417 H 1.3016667 V 7.71925 H 14.281667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.064083,0.56833333 H 7.3525833 c -0.2025833,0 -0.3666666,0.165 -0.3666666,0.36666667 v 4.54575 c 0,0.2025833 0.1640833,0.3666667 0.3666666,0.3666667 0.2025834,0 0.3666667,-0.165 0.3666667,-0.3666667 V 1.3025833 H 20.698333 V 14.28075 H 16.51925 c -0.202583,0 -0.366667,0.165 -0.366667,0.366667 0,0.201666 0.164084,0.366666 0.366667,0.366666 H 21.065 c 0.202583,0 0.366667,-0.165 0.366667,-0.366666 V 0.93591667 c -9.17e-4,-0.20258334 -0.165,-0.36758334 -0.367584,-0.36758334 z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.fa5ca6fa2f514a6f49a8e99e9faeba80.svg";
export { ForwardRef as ReactComponent };